module.exports = __webpack_public_path__ + "static/media/logo125.64fa52fb.png";